function Contact() {

const handleResumeClick = (e) => {
e.preventDefault();
alert("Resume will be added soon 🚀");
};

return (


<section id="contact" className="reveal">

  <div className="section-title">
    <h2>Contact</h2>
  </div>

  <div className="contact-layout">

    <div className="contact-left">

      <h3>Let's Build Something Together</h3>

      <p>
        I am currently open to internship opportunities, collaborations,
        and interesting projects in software development, AI, and creative technology.
        If you would like to work together or discuss ideas, feel free to reach out.
      </p>

    </div>

    <div className="contact-right">

      <a
        href="mailto:chaitanyaram69@gmail.com"
        className="contact-item"
      >
        📧 <strong>Email</strong>
        <span>chaitanyaram69@gmail.com</span>
      </a>

      <a
        href="https://www.linkedin.com/in/banka-lakshmi-chaitanya-ram-5bab24385/"
        target="_blank"
        rel="noopener noreferrer"
        className="contact-item"
      >
        💼 <strong>LinkedIn</strong>
        <span>Connect professionally</span>
      </a>

      <a
        href="https://github.com/Banka-Lakshmi-Chaitanya-Ram?tab=repositories"
        target="_blank"
        rel="noopener noreferrer"
        className="contact-item"
      >
        🐙 <strong>GitHub</strong>
        <span>View repositories</span>
      </a>

      <a
        href="/"
        onClick={handleResumeClick}
        className="contact-item"
      >
        📄 <strong>Download CV</strong>
        <span>Resume coming soon</span>
      </a>

    </div>

  </div>

</section>


);

}

export default Contact;
